import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";

// スタイルインポート
import "./css/Main.scss";
import "./responsive/MainResponsive.scss";
import "./css/Reset.scss";
import "./common.scss";

// ロゴイメージ
import headerImg from "./img/top/banner-right-image.png";
import aboutImg from "./img/top/group-pic.png";

// サービス一覧
import serviceImg1 from "./img/top/service-homepage.webp";
import serviceImg2 from "./img/top/service-webapp.jpeg";
import serviceImg3 from "./img/top/service-design.webp";
import serviceImg4 from "./img/top/service-ecsite.jpeg";

// 問題点
import problemImg from "./img/top/problems2.svg";

// メリット
import meritImg1 from "./img/common/tp-merit-one.svg";
import meritImg2 from "./img/common/tp-merit-two.svg";
import meritImg3 from "./img/common/tp-merit-three.svg";
import meritImg4 from "./img/common/tp-merit-four.svg";

// 制作事例
import workImg1 from "./img/works/work01.png";
import workImg2 from "./img/works/ec-works.jpg";

import comPic from "./img/top/laptop-analytics.webp";

import { motion, AnimateSharedLayout } from "framer-motion";
import { useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

function Main() {
    const { ref, inView } = useInView();
    const fadeup = useAnimation();

    useEffect(() => {
        if (inView) {
            fadeup.start({
                y: 0,
                opacity: 1,
                transition: {
                    type: "spring",
                    duration: 2,
                },
            });
        }
        if (!inView) {
            fadeup.start({ y: "30px", opacity: 0 });
        }
    });
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    return (
        <>
            <HelmetProvider>
                <Helmet prioritizeSeoTags>
                    <meta charset="utf-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1"
                    />
                    <meta name="theme-color" content="#005bac" />
                    <meta
                        name="keywords"
                        content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン"
                    />
                    <meta
                        name="description"
                        content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
                    />
                    <meta
                        property="og:title"
                        content="千葉県千葉市でのホームページ制作ならSmartGenz | トップページ"
                    />
                    <meta
                        property="og:description"
                        content="千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。"
                    />
                    <meta property="og:type" content="article" />
                    <meta property="og:url" content="https://smartgenz.com/" />
                    <meta
                        property="og:image"
                        content="%PUBLIC_URL%/smartgenz.jpg"
                    />
                    <meta
                        property="og:site_name"
                        content="千葉県千葉市でのホームページ制作ならSmartGenz"
                    />
                    <meta property="og:locale" content="ja_JP" />
                    <link
                        rel="apple-touch-icon"
                        href="%PUBLIC_URL%/smartgenz.jpg"
                    />
                    <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
                    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
                    <link rel="canonical" href="https://smartgenz.com/" />
                    <title>
                        千葉県千葉市でのホームページ制作ならSmartGenz |
                        トップページ
                    </title>
                </Helmet>
            </HelmetProvider>
            <motion.div
                className="main"
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
            >
                <article className="header-image">
                    <div className="header-main-image">
                        <h2 className="header-description">
                            <div className="ttl-one">Smart and</div>
                            <div className="ttl-two">
                                <span className="spOnly">Simple Solutions</span>
                                <span className="pcOnly">Simple Solutions</span>
                            </div>
                            <p className="pcOnly">
                                <span>スマートかつシンプルに</span>
                            </p>
                            <p className="spOnly">
                                <span>スマートかつシンプルに</span>
                            </p>
                            <p className="pcOnly mt45">
                                <span>
                                    高品質なWEBデザイン、WEB集客に強いホームページを構築できるWEB制作事務所です。共同制作者が何人か在籍しているためスピード、質、サポート体制が特に期待できます。WEBのことならSmartGenzへお任せください！
                                </span>
                            </p>
                            <p className="spOnly">
                                <span>
                                    高品質なWEBデザイン、WEB集客に強いホームページを構築できるWEB制作事務所です。共同制作者が何人か在籍しているためスピード、質、サポート体制が特に期待できます。WEBのことならSmartGenzへお任せください！
                                </span>
                            </p>
                        </h2>
                        <img
                            className="pcOnly"
                            src={headerImg}
                            alt="アイテム　｜ ヘッダーイメージ"
                        ></img>
                    </div>
                </article>
                <div className="computer">
                    <img src={comPic} alt="" />
                </div>
                <ScrollToTop />
                <div className="ads">
                    <div className="ads-title">アフィリエイトパートナー</div>
                    <a
                        href="https://px.a8.net/svt/ejp?a8mat=3T00KF+DIF60I+CO4+15TP8X"
                        rel="nofollow"
                    >
                        <img
                            border="0"
                            width="100%"
                            height="100%"
                            alt=""
                            src="https://www24.a8.net/svt/bgt?aid=230108127817&wid=001&eno=01&mid=s00000001642007025000&mc=1"
                        />
                    </a>
                    <img
                        border="0"
                        width="1"
                        height="1"
                        src="https://www15.a8.net/0.gif?a8mat=3T00KF+DIF60I+CO4+15TP8X"
                        alt=""
                    />
                    <a
                        href="https://px.a8.net/svt/ejp?a8mat=3SZZ09+6C11GY+50+2HH8I9"
                        rel="nofollow"
                    >
                        <img
                            border="0"
                            width="100%"
                            height="100%"
                            alt=""
                            src="https://www27.a8.net/svt/bgt?aid=230106105383&wid=001&eno=01&mid=s00000000018015029000&mc=1"
                        />
                    </a>
                    <img
                        border="0"
                        width="1"
                        height="1"
                        src="https://www10.a8.net/0.gif?a8mat=3SZZ09+6C11GY+50+2HH8I9"
                        alt=""
                    />
                </div>

                <section className="tp-about-section" ref={ref}>
                    <h3 class="tp-sec-tl typo-en" data-num="01/">
                        ABOUT
                        <span>わたしについてご紹介させて頂きます</span>
                    </h3>

                    <motion.div animate={fadeup}>
                        <div className="tp-sec-about-contents">
                            <img
                                src={aboutImg}
                                alt="アイテム　｜ 私についてイメージ"
                            ></img>
                            <div className="tp-sec-about-contents-txt">
                                <div className="tp-sec-about-contents-txt-tl">
                                    SIMPLE MIND MAKES A
                                    <span className="blue ml15">
                                        GREAT IMPACT
                                    </span>
                                </div>
                                <p className="fonW500">
                                    SIMPLE MINDはの略は「シンプルな思考」、GREAT
                                    IMPACTは日本語で「大きな影響」と意味します。つまり最大な効果をもたらすのはシンプルな思考だと考えています。
                                    <br />
                                    これまで見てきた売れている商品またはサービスの中に共通してるもの一点あり、それは情報量が少なくシンプルな見た目となっているものです。
                                    <br />
                                    私たちSmartGenzはシンプルな思考を活用して、お客様のあらゆるＷＥＢ媒体上の課題を解決します。
                                </p>
                                <Link to="/about">
                                    <div className="btn typo-en">
                                        <div className="btn-txt borderleft">
                                            <span>MORE</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/about">
                                    <div class="btn-sp typo-en">
                                        <div class="btn-txt">MORE</div>
                                    </div>
                                </Link>
                                <div class="fluid"></div>
                            </div>
                        </div>
                    </motion.div>
                </section>
                <section className="tp-services-section">
                    <h3 class="tp-sec-tl typo-en" data-num="02/">
                        SERVICE
                        <span>
                            わたしが提供できるソリューションをご紹介します
                        </span>
                    </h3>

                    <div className="tp-sec-services-contents">
                        <div className="tp-sec-service-one">
                            <div className="service-priorty">MAIN</div>
                            <div className="service-ttl" data-sr-num="01">
                                SERVICE
                            </div>
                            <div className="tp-sec-service-img">
                                <img
                                    loading="lazy"
                                    src={serviceImg1}
                                    alt="アイテム　｜ サービス一覧01"
                                ></img>
                            </div>
                            <div className="service-all-ttl">
                                WEB制作・ホームページ制作
                            </div>
                            <p className="service-all-txt">
                                ホームページ訪問者の記憶や印象に強く訴えるホームページ制作により、PCやスマホなどのデバイスを問わず、お客様の強力なビジネスソリューションとしてご提供します。
                            </p>
                        </div>
                        <div className="tp-sec-service-two">
                            <div className="service-priorty other">OTHER</div>
                            <div className="service-ttl" data-sr-num="02">
                                SERVICE
                            </div>
                            <div className="tp-sec-service-img">
                                <img
                                    loading="lazy"
                                    src={serviceImg2}
                                    alt="アイテム　｜ サービス一覧01"
                                ></img>
                            </div>
                            <div className="service-all-ttl">WEB開発支援</div>
                            <p className="service-all-txt">
                                フロントエンドを中心に開発支援いたします。
                                長年放置されたコード(CSSやJavascript)のリファクタリングを通して、スピード改善や運用費のコストダウンなども提案させていただきます。
                            </p>
                        </div>
                        <div className="tp-sec-service-three">
                            <div className="service-priorty other">OTHER</div>
                            <div className="service-ttl" data-sr-num="03">
                                SERVICE
                            </div>
                            <div className="tp-sec-service-img">
                                <img
                                    loading="lazy"
                                    src={serviceImg3}
                                    alt="アイテム　｜ サービス一覧01"
                                ></img>
                            </div>
                            <div className="service-all-ttl">
                                グラフィックデザイン制作
                            </div>
                            <p className="service-all-txt">
                                ロゴ制作やパンフレット制作をはじめとして、ご予算や目的、ターゲットに応じて、印刷物の形態や形状、紙質などとあわせてブランディングツールをご提案いたします。
                            </p>
                        </div>
                        <div className="tp-sec-service-four">
                            <div className="service-priorty other">OTHER</div>
                            <div className="service-ttl" data-sr-num="04">
                                SERVICE
                            </div>
                            <div className="tp-sec-service-img">
                                <img
                                    loading="lazy"
                                    src={serviceImg4}
                                    alt="アイテム　｜ サービス一覧01"
                                ></img>
                            </div>
                            <div className="service-all-ttl">
                                英語版ホームページ制作
                            </div>
                            <p className="service-all-txt">
                                グローバル化が進む中、国際的な存在感を高めるため、英語版ホームページに力を入れたいお客様のため、
                                海外向けに徹底した「ネイティブデザイン」で「世界に通用する」Webサイトを制作
                            </p>
                        </div>
                    </div>

                    {/* <div className="btn-service">
          <button>MORE</button>
        </div> */}
                </section>
                <section className="tp-problems-section">
                    <h3 class="tp-sec-tl typo-en" data-num="03/">
                        STRENGTH
                        <span>SmartGenzの強み</span>
                    </h3>
                    <div className="tp-sec-problem-contents">
                        <div className="tp-sec-problem-question">
                            <div className="tp-sec-problem-ttl">
                                私たちの最大の強み
                            </div>
                            <div className="tp-sec-problem-txt">
                                <p>
                                    私たちSmartGenzの最大な強みは第一印象に「DD法則」の活用です。
                                </p>
                                <p>
                                    DDの略はDramatic
                                    Demonstration（印象的なデモンストレーション）この思考をサイト訪問者へ与えることで興味へと繋がり、お客様の最終的な目標へと繋がります。{" "}
                                </p>
                            </div>
                        </div>
                        <div className="tp-sec-problem-img">
                            <img src={problemImg}></img>
                        </div>
                    </div>
                </section>
                <section className="tp-merits-section">
                    <h3 class="tp-sec-tl typo-en" data-num="04/">
                        MERITS
                        <span>
                            お客様のご要望に合わせて、ピッタリなサイトを制作いたします。
                            <br />
                            また、制作後のセキュリティもしっかりと管理していきます。
                        </span>
                    </h3>
                </section>
                <div className="tp-sec-merit-contents">
                    <div className="tp-sec-merit-boxes">
                        <div className="tp-sec-merit-box-one box">
                            <div className="tp-sec-merit-box-ttl">
                                経験豊かなプロ制作者
                            </div>
                            <div className="tp-sec-merit-img">
                                <img src={meritImg1}></img>
                            </div>
                            <div className="tp-sec-merit-box-desc">
                                案件ごとにスキル・コミュニケーション能力が高い個人事業主にサポートしてもらうことができます。
                            </div>
                        </div>
                        <div className="tp-sec-merit-box-two box">
                            <div className="tp-sec-merit-box-ttl">
                                フレキシブル対応
                            </div>
                            <div className="tp-sec-merit-img">
                                <img src={meritImg2}></img>
                            </div>
                            <div className="tp-sec-merit-box-desc">
                                お客様のご予算に合わせて、最も最適なプランをご提案させていただきます。
                            </div>
                        </div>
                        <div className="tp-sec-merit-box-three box">
                            <div className="tp-sec-merit-box-ttl">
                                高品質かつコストは安く
                            </div>
                            <div className="tp-sec-merit-img">
                                <img src={meritImg3}></img>
                            </div>
                            <div className="tp-sec-merit-box-desc">
                                SmartGenzには営業専門職、総務専門職は存在しませんので、人件費や経費を抑えることができます。
                            </div>
                        </div>
                        <div className="tp-sec-merit-box-four box">
                            <div className="tp-sec-merit-box-ttl">
                                一貫してプロの
                                <br />
                                制作者が担当
                            </div>
                            <div className="tp-sec-merit-img">
                                <img src={meritImg4}></img>
                            </div>
                            <div className="tp-sec-merit-box-desc">
                                初めてで何もわからなくてもご安心ください。制作前の準備、必要なもの・公開後の更新方法など丁寧にサポートさせていただきます。
                            </div>
                        </div>
                    </div>
                </div>
                <section className="tp-works-section">
                    <h3 class="tp-sec-tl typo-en" data-num="05/">
                        SAMPLE WORKS
                        <span>わたしたちが制作した事例を紹介いたします。</span>
                    </h3>
                    <Link to="/works">
                        <div className="tp-sec-work-contents">
                            <div className="tp-sec-work-boxes">
                                <div className="tp-sec-work-web">
                                    <img
                                        loading="lazy"
                                        src={workImg1}
                                        alt=""
                                    ></img>
                                    <div className="tp-sec-work-web-desc">
                                        <p>ホームページ</p>
                                        <p>https://raumennoyoshiei.com/</p>
                                    </div>
                                </div>
                                {/* {/* <div className="tp-sec-work-designs">
							<div className="tp-sec-work-busscard">
								<img src={workImg2} alt=""></img>
								<div className="tp-sec-work-busscard-desc">
									<p>ホームページ</p>
									<p>www.ramennoyoshie.com</p>
								</div>
							</div>
							<div className="tp-sec-work-pamflet">
								<img src={workImg3} alt=""></img>
								<div className="tp-sec-work-pamflet-desc">
									<p>ホームページ</p>
									<p>www.ramennoyoshie.com</p>
								</div>
							</div >
						</div> } */}
                            </div>
                        </div>
                    </Link>
                    <h3 class="tp-sec-tl typo-en mt30" data-num="05.1/">
                        PORTFOLIO
                        <span>
                            わたしたちのポートフォリオを紹介いたします。
                        </span>
                    </h3>
                    <Link to="/portfolio">
                        <div className="tp-sec-work-contents mt30">
                            <div className="tp-sec-work-boxes">
                                <div className="tp-sec-work-web">
                                    <img src={workImg2} alt=""></img>
                                    <div className="tp-sec-work-web-desc">
                                        <p>
                                            管理サイト：ファッション通販サイト
                                        </p>
                                        <p>担当フェーズ：実装業務</p>
                                    </div>
                                </div>

                                {/* {/* <div className="tp-sec-work-designs">
							<div className="tp-sec-work-busscard">
								<img src={workImg2} alt=""></img>
								<div className="tp-sec-work-busscard-desc">
									<p>ホームページ</p>
									<p>www.ramennoyoshie.com</p>
								</div>
							</div>
							<div className="tp-sec-work-pamflet">
								<img src={workImg3} alt=""></img>
								<div className="tp-sec-work-pamflet-desc">
									<p>ホームページ</p>
									<p>www.ramennoyoshie.com</p>
								</div>
							</div >
						</div> } */}
                            </div>
                        </div>
                    </Link>
                </section>
                <section className="tp-packages-section">
                    <h3 class="tp-sec-tl typo-en" data-num="06/">
                        PACKAGES
                        <span>基本的なパッケージをご紹介します</span>
                        <div className="notice">
                            <p>
                                <text>
                                    お客様のご要望次第で、価格を柔軟に対応します。是非ご相談ください。
                                </text>
                            </p>
                            <p>
                                <text>
                                    ご依頼方法/制作依頼に関する注意事項は{" "}
                                    <a href="/">こちら</a>
                                    をご覧ください。
                                </text>
                            </p>
                        </div>
                    </h3>
                    <div className="tp-sec-package-contents">
                        <div className="tp-sec-package-boxes">
                            <div className="tp-sec-package-box-button">
                                <div className="tp-sec-package-box-one box">
                                    <div className="tp-sec-package-box-ttl">
                                        スタータパッケージ
                                    </div>
                                    <div className="tp-sec-package-box-price">
                                        WEB制作の基本を全て
                                    </div>
                                    <div className="tp-sec-package-box-color">
                                        個人または個人事業主向け
                                    </div>
                                    <ul className="tp-sec-package-desc">
                                        <li>納期目安：７日～１４日</li>
                                        <li>ページ数：３ページまで</li>
                                        <li>セキュリティ：SSL</li>
                                        <li>SEO対策：簡易</li>
                                        <li>GoogleAnalytics：初期設定</li>
                                        <li>モバイル・レスポンシブ対応</li>
                                        <li>
                                            画像掲載（ページごとに５枚まで）
                                        </li>
                                    </ul>
                                </div>
                                {/* <div class="btn typo-en">
                <div class="btn-txt">MORE</div>
                <div class="btn-line"></div>
              </div> */}
                            </div>
                            <div className="tp-sec-package-box-two box">
                                <div className="tp-sec-package-box-ttl">
                                    デザインパッケージ
                                </div>
                                <div className="tp-sec-package-box-price">
                                    独自な機能とデザイン
                                </div>
                                <div className="tp-sec-package-box-color">
                                    小企業向け
                                </div>
                                <ul className="tp-sec-package-desc">
                                    <li>納期目安：３０日～４５日</li>
                                    <li>ページ数：６ページまで</li>
                                    <li>セキュリティ：SSL</li>
                                    <li>SEO対策：内部SEO対応</li>
                                    <li>GoogleAnalytics:初期設定</li>
                                    <li>モバイル・レスポンシブ対応</li>
                                    <li>画像掲載（ページごとに７枚まで）</li>
                                    <li>お問い合わせフォーム</li>
                                    <li>デザイン：カスタマイズ</li>
                                    <li>ドメイン取得代行</li>
                                    <li>サーバー契約</li>
                                    <li>サーバ設定</li>
                                </ul>
                            </div>
                            <div className="tp-sec-package-box-three box">
                                <div className="tp-sec-package-box-ttl">
                                    オーダメイドパッケージ
                                </div>
                                <div className="tp-sec-package-box-price">
                                    Google上位検索と上品質
                                </div>
                                <div className="tp-sec-package-box-color">
                                    中小企業向け
                                </div>
                                <ul className="tp-sec-package-desc">
                                    <li>納期目安：５０日～９０日</li>
                                    <li>ページ数：最適数をご提案</li>
                                    <li>セキュリティ：SSL</li>
                                    <li>SEO対策：強化版</li>
                                    <li>
                                        GoogleAnalytics:納品後２回レポート提出
                                    </li>
                                    <li>モバイル・レスポンシブ対応</li>
                                    <li>
                                        画像掲載（ページごとに何枚でも可能）
                                    </li>
                                    <li>お問い合わせフォーム</li>
                                    <li>デザイン：オーダーメイド</li>
                                    <li>更新システム：導入可能</li>
                                    <li>機能追加：対応可能</li>
                                    <li>移管作業：可能</li>
                                    <li>写真撮影：出張費別</li>
                                    <li>ドメイン取得代行</li>
                                    <li>サーバー契約</li>
                                    <li>サーバ設定</li>
                                </ul>
                            </div>
                            {/* <div class="btn-sp typo-en">
							<div class="btn-txt">MORE</div>
							<div class="btn-line"></div>
						</div> */}
                        </div>
                    </div>
                </section>
                {/* <section className="tp-project-section">
				<h3 class="tp-sec-tl typo-en" data-num="07/">
					PROJECTS
					<span>現在製作中のプロジェクトをご紹介します</span>
				</h3>
				<div className="tp-sec-work-contents">
					<div className="tp-sec-work-img">
						<img className="img1" src={projectImg1} alt=""></img>
						<img className="img2" src={projectImg2} alt=""></img>
					</div>
					<div className="tp-sec-work-desc">
						<div className="tp-sec-work-desc-ttl">
							無料動画配信アプリケーション
						</div>
						<div className="tp-sec-work-desc-txt">
							現在製作中のウェブサイトをご紹介します。目的としては、こちらのウェブサイトをご覧いただいたお客様へモダン技術がどいうふうなサイトを作成できるのかイメージしやすいように制作しています。
						</div>
						<div className="tp-sec-work-desc-requir">
							<ul>
								<li>開発言語：REACT</li>
								<li>データベース：FIRESHIP</li>
								<li>デモサイト：www.000.com</li>
							</ul>
						</div>
					</div>
				</div>
			</section> */}
                <Contact />
                <Footer />
            </motion.div>
        </>
    );
}

export default Main;
